import { useState } from "react";

import { toast } from "@picklebet/ui";
import { confirmCashOut } from "../services/confirm-cash-out";

const ERROR_CODES = [
  "amount-has-changed",
  "cashed-out-failed",
  "bet-ineligible",
  "live-market",
  "bet-not-active",
  "bet-not-found",
];

const useConfirmCashOut = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirm = async (betId: string, amount: number) => {
    setError(null);
    setLoading(true);

    const result = await confirmCashOut({ betId, amount });

    setLoading(false);

    if (!result.ok) {
      setError(result.error.message);
      toast({
        variant: "danger",
        description: result.error.message,
      });

      return false;
    }

    if (ERROR_CODES.includes(result.data?.code ?? "")) {
      const errorMessage =
        result.data?.displayText ??
        "Failed to cashout, please contact support.";
      setError(errorMessage);
      toast({
        variant: "danger",
        description: errorMessage,
      });

      return false;
    }

    return true;
  };

  return {
    confirmCashOut: confirm,
    isCashingOut: loading,
    error,
  };
};

export { useConfirmCashOut };
